import { Component, inject, signal } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-sku.dialog',
  standalone: false,
  templateUrl: './sku.dialog.component.html',
  styleUrl: './sku.dialog.component.scss'
})
export class SkuDialogComponent {
  dialogRef = inject(MatDialogRef<SkuDialogComponent, string>);
  isConfirming = signal(false);
  newSKU: string | null = null;

  inputKeyDown(e: KeyboardEvent) {
    if (e.key === 'Enter') {
      this.searchSKU();
    }
  }

  searchSKU() {
    this.isConfirming.set(true);
  }
}
